import { useMediaQuery, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { CloudQuestionIcon, InfoCircleIcon } from 'src/assets/icons'
import { HelperWrapper, SettingsDropdown } from 'src/components'
import { MobileSettings } from './mobile.component'
import { CloseAccountButton } from './close-account-button.component'
import { ExposePrivateKeyButton } from 'src/components/expose-private-key-modal/expose-private-key-button.component'

import { useStyles } from '../styles'
import { useRequestAccountPrivateKey, useVerifyAccountPrivateKeyRequest } from 'src/hooks'
import { ETranslationNs, PrivateKeyRequestFn, PrivateKeyVerifyFn } from 'src/types'

const Settings = () => {
  const [t] = useTranslation([ETranslationNs.Common, ETranslationNs.Navbar])
  const classes = useStyles()
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))

  if (isTablet) {
    return <MobileSettings />
  }

  const handleHelpClick = () => {
    //@ts-ignore
    window.Intercom('show')
  }

  return (
    <div
    // className={classes.itemBorder}
    >
      {/* <div className={classes.itemUpperWrapper}>
        <h3 className={classes.itemTitle}>
          <HelperWrapper ns={ETranslationNs.Navbar} t="account-settings-header-title" />
        </h3>
      </div> */}
      <div className={classes.settingsWrapper}>
        <div className={classes.settingsBottomWrapper}>
          <div className={classes.settingsItemsWrapper}>
            <div className={`${classes.itemBorder} ${classes.settingsItemWrapper}`}>
              <h4 className={classes.itemSubtitle}>
                <HelperWrapper t="account-support-privacy-section" />
              </h4>
              <div className={classes.settingsItems}>
                <div className={classes.settingsItem}>
                  <SettingsDropdown
                    text={t('account-support-privacy-dropdown.v')}
                    icon={<InfoCircleIcon />}
                  />
                </div>
                <div className={classes.settingsItem}>
                  <ExposePrivateKeyButton
                    verifyFn={useVerifyAccountPrivateKeyRequest as PrivateKeyVerifyFn}
                    requestFn={useRequestAccountPrivateKey as PrivateKeyRequestFn}
                  />
                </div>
              </div>
            </div>
            <div className={`${classes.itemBorder} ${classes.settingsItemWrapper}`}>
              <h4 className={classes.itemSubtitle}>
                <HelperWrapper t="account-support-help-section" />
              </h4>
              <div className={classes.settingsItems}>
                <div className={classes.settingsItem}>
                  <SettingsDropdown
                    onButtonClick={handleHelpClick}
                    text={t('account-support-help-section.v')}
                    icon={<CloudQuestionIcon />}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={`${classes.itemBorder} ${classes.settingsActionWrapper}`}>
            <h4 className={classes.itemSubtitle}>
              <HelperWrapper t="account-support-action-section" />
            </h4>
            <div className={classes.settingsItems}>
              <div className={classes.settingsItem}>
                <CloseAccountButton />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { Settings }
